import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/images/pantry_camera.png'
import _imports_1 from '@/assets/images/pantry_list.png'
import _imports_2 from '@/assets/images/pantry_virtual.png'
import _imports_3 from '@/assets/images/icon_pantry_shoplist_off.png'
import _imports_4 from '@/assets/images/icon_pantry_search.png'
import _imports_5 from '@/assets/images/icon_pantry_edit.png'


const _hoisted_1 = { class: "pantry-page" }
const _hoisted_2 = { class: "pantry-page-area" }
const _hoisted_3 = { class: "pantry-page-header-view-area" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-page-fab-menu-image-icon",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "pantry-page-header-view-right-area" }
const _hoisted_6 = { class: "pantry-page-header-view-right-list-area" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-page-fab-menu-image-icon",
  src: _imports_1
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-page-fab-menu-image-icon",
  src: _imports_2
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-page-fab-menu-image-icon",
  src: _imports_3
}, null, -1)
const _hoisted_10 = { class: "pantry-page-fab-view" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-page-fab-menu-icon",
  src: _imports_4
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-page-fab-menu-icon",
  src: _imports_5
}, null, -1)
const _hoisted_13 = { class: "pantry-page-search-view-area" }
const _hoisted_14 = { class: "pantry-page-food-search-view-area" }
const _hoisted_15 = { class: "pantry-page-select-delete-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryListView = _resolveComponent("PantryListView")
  const _component_PantryVirtualView = _resolveComponent("PantryVirtualView")
  const _component_PantrySearchView = _resolveComponent("PantrySearchView")
  const _component_PantryRecipeSearchView = _resolveComponent("PantryRecipeSearchView")
  const _component_PantrySelectDeleteBar = _resolveComponent("PantrySelectDeleteBar")
  const _component_PantrySearchDialog = _resolveComponent("PantrySearchDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_PantryListView, {
        key: _ctx.updateListKey,
        list: _ctx.pantryList,
        selectMode: _ctx.isListSelectMode,
        sortType: _ctx.sortType,
        searchMode: _ctx.isShowSearch,
        isShow: _ctx.isShowList,
        isRefreshEnabled: _ctx.isRefreshEnabled,
        onListSelectMode: _ctx.clickListSelectMode,
        onSelectSortType: _ctx.selectSortType,
        onSelectCheck: _ctx.onSelectListItemCheck,
        onClickFood: _ctx.onSelectListPantry,
        onClickFavorite: _ctx.onClickFavorite,
        onClickShoplist: _ctx.onClickAddShoppingList,
        onChangeValue: _ctx.changeValue,
        onRefresh: _ctx.refreshList,
        onScrollEnd: _ctx.onScrollEndList
      }, null, 8, ["list", "selectMode", "sortType", "searchMode", "isShow", "isRefreshEnabled", "onListSelectMode", "onSelectSortType", "onSelectCheck", "onClickFood", "onClickFavorite", "onClickShoplist", "onChangeValue", "onRefresh", "onScrollEnd"]), [
        [_vShow, _ctx.selectPosition == 0]
      ]),
      _withDirectives(_createVNode(_component_PantryVirtualView, {
        list: _ctx.pantryVirtualList,
        selectMode: _ctx.isShowSearch,
        isShow: _ctx.isShowVirtualList,
        isRefreshEnabled: _ctx.isRefreshEnabled,
        searchMode: _ctx.isShowSearch,
        onSelectCheck: _ctx.onSelectVirtualPantry,
        onRefresh: _ctx.refreshVirtual,
        onScrollEnd: _ctx.onScrollEndVirtual
      }, null, 8, ["list", "selectMode", "isShow", "isRefreshEnabled", "searchMode", "onSelectCheck", "onRefresh", "onScrollEnd"]), [
        [_vShow, _ctx.selectPosition == 2]
      ])
    ]),
    _createVNode("div", {
      class: "pantry-page-header-view",
      style: _ctx.styleHeaderBackground
    }, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("div", {
          class: "pantry-page-header-camera",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShowCamera(...args)))
        }, [
          _hoisted_4
        ], 512), [
          [_vShow, _ctx.isShowCamera]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_ctx.selectPosition != 0)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "pantry-page-header-list",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelect(0)))
              }, [
                _hoisted_7
              ]))
            : (_ctx.selectPosition != 2)
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "pantry-page-header-list",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelect(2)))
                }, [
                  _hoisted_8
                ]))
              : _createCommentVNode("", true),
          _createVNode("div", {
            class: "pantry-page-header-shop-list",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickShowShoppingList(...args)))
          }, [
            _hoisted_9
          ])
        ])
      ])
    ], 4),
    _withDirectives(_createVNode("div", _hoisted_10, [
      _createVNode("div", {
        class: "pantry-page-fab-menu",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClickSearch(...args)))
      }, [
        _hoisted_11
      ]),
      _createVNode("div", {
        class: "pantry-page-fab-menu",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickMenu(...args)))
      }, [
        _hoisted_12
      ])
    ], 512), [
      [_vShow, _ctx.isShowFabView]
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_PantrySearchView, _mergeProps({
        style: { height: _ctx.getSearchViewHeight() }
      }, _ctx.isShowList, {
        class: "pantry-page-search-view",
        key: _ctx.updateRecipeSearchKey,
        list: _ctx.recipeSearchList,
        searchFoodList: _ctx.searchFoodList,
        isShowList: _ctx.isShowList,
        onClickClose: _ctx.onSeachClose,
        onClickSearch: _ctx.onShowFoodSearch,
        onSwipeUp: _ctx.onSwipeUp,
        onSwipeDown: _ctx.onSwipeDown,
        onDeleteFood: _ctx.onDeleteFood,
        onSelectRecipe: _ctx.onSelectRecipe,
        onClickSearchDialog: _ctx.onSearchDialog,
        onScrollEnd: _ctx.onScrollEndRecipeSearch
      }), null, 16, ["style", "list", "searchFoodList", "isShowList", "onClickClose", "onClickSearch", "onSwipeUp", "onSwipeDown", "onDeleteFood", "onSelectRecipe", "onClickSearchDialog", "onScrollEnd"])
    ]),
    _withDirectives(_createVNode("div", _hoisted_14, [
      _createVNode(_component_PantryRecipeSearchView, {
        key: _ctx.updateKeywordKey,
        list: _ctx.recipeFoodList,
        onClickClose: _ctx.onFoodSearchClose,
        onClickSearch: _ctx.onFoodSearch,
        onSelectFood: _ctx.onSelectFood
      }, null, 8, ["list", "onClickClose", "onClickSearch", "onSelectFood"])
    ], 512), [
      [_vShow, _ctx.isShowFoodSearch]
    ]),
    _withDirectives(_createVNode("div", _hoisted_15, [
      _createVNode(_component_PantrySelectDeleteBar, { onClickItem: _ctx.clickSelectDeleteItem }, null, 8, ["onClickItem"])
    ], 512), [
      [_vShow, _ctx.isShowSelectDeleteBar]
    ]),
    _createVNode(_component_PantrySearchDialog, {
      key: _ctx.updateDialogKey,
      isShowDialog: _ctx.isShowPantrySearchDialog,
      "v-bind": _ctx.tagGroupsInfoList,
      tagGroupsInfo: _ctx.tagGroupsInfoList,
      onClickClose: _ctx.onSearchDialogClose,
      onClickSetting: _ctx.onSearchDialogSetting,
      onSelectTag: _ctx.onSelectTag
    }, null, 8, ["isShowDialog", "v-bind", "tagGroupsInfo", "onClickClose", "onClickSetting", "onSelectTag"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowPlateFoodChange,
      dialogType: 18,
      title: '',
      message: '食材を追加しますか？\n\n重さリセットからの設定となります。',
      negativeLabel: 'キャンセル',
      positiveLabel: 'OK',
      onNegativeClick: _ctx.onClickPlateFoodChangeNegative,
      onPositiveClick: _ctx.onClickPlateFoodChangePositive
    }, null, 8, ["isShowDialog", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDeleteFoodCheck,
      dialogType: 18,
      title: '',
      message: '選択した食材をリストから削除します。\nよろしいですか？',
      negativeLabel: 'キャンセル',
      positiveLabel: '削除する',
      onNegativeClick: _ctx.onClickDeleteFoodCheckNegative,
      onPositiveClick: _ctx.onClickDeleteFoodCheckPositive
    }, null, 8, ["isShowDialog", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowErrorEmpty,
      dialogType: 8,
      title: '項目が選択されていません。',
      negativeLabel: 'OK',
      onNegativeClick: _ctx.onClickErrorEmpty
    }, null, 8, ["isShowDialog", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDeleteComplite,
      dialogType: 12,
      title: _ctx.deleteCompliteMessage,
      negativeLabel: '閉じる',
      onNegativeClick: _ctx.onClickDeleteComplite
    }, null, 8, ["isShowDialog", "title", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowCheckValueDelete,
      dialogType: 6,
      title: '',
      message: _ctx.selectMessage,
      messageAlign: 1,
      negativeLabel: '捨てちゃった',
      positiveLabel: '使い切った',
      onCloseClick: _ctx.onClickValueDeleteClose,
      onNegativeClick: _ctx.onClickValueDeleteNegative,
      onPositiveClick: _ctx.onClickValueDeletePositive
    }, null, 8, ["isShowDialog", "message", "onCloseClick", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}